export function getSiblings(elem) {
	var siblings = []
	var sibling = elem.parentNode.firstChild
	for ( ; sibling; sibling = sibling.nextSibling ) {
			if ( sibling.nodeType === 1 && sibling !== elem ) {
					siblings.push( sibling )
			}
	}
	return siblings;
}

export const slice = Array.prototype.slice

export function setVendor(element, property, value) {
	element.style["Webkit" + property] = value
	element.style["Moz" + property] = value
	element.style["ms" + property] = value
	element.style["o" + property] = value
	element.style[property] = value
}



// WEBPACK FOOTER //
// ./resources/assets/js/partials/Helpers.js